import React, {Fragment} from 'react'
import {Link, useLoaderData, useRouteLoaderData} from '@remix-run/react'
import clsx from 'clsx'
import {getDomainConfig} from '~/domains'
import {getTranslation} from '~/localization/translation'
import type {CategoriesDataProps, RootLoaderResponse} from '~/types'
import {useReportWidgetClick, useReportWidgetSeen} from '~/hooks/analytic-hooks'

const ExploreLists = () => {
  const {language, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const translations = getTranslation(language)
  const {styles: stylesBydomain} = getDomainConfig(domain, locale)
  const {newHomePageData} = useLoaderData() as CategoriesDataProps
  const {categoriesToExplore} = newHomePageData?.homepageData || {}

  const [widgetRef] = useReportWidgetSeen({
    widget_name: 'explore-lists',
    widget_place: 'middle',
  })

  const reportWidgetClick = useReportWidgetClick()

  const displayItems = categoriesToExplore && categoriesToExplore?.length > 1

  return (
    displayItems && (
      <div
        className={clsx('mx-auto flex flex-col gap-4', stylesBydomain.UTILS_MAIN_CONTAINER, 'utils_main_container')}
        ref={widgetRef}
      >
        <h3 className="text-center text-xl font-bold">{translations.Home.ExploreLists.title}</h3>
        <div className="grid grid-cols-6 gap-4 tablet:grid-cols-3">
          {categoriesToExplore?.map(({browseNodeName, slug, image}, i) => (
            <Fragment key={`${i}-${slug}`}>
              <Link
                to={`/${slug}`}
                prefetch="intent"
                aria-label={`view ${browseNodeName}`}
                className="flex flex-col items-center justify-center gap-2 rounded-xl border border-[#D5D9D9] px-2 pb-2 pt-4"
                onClick={() =>
                  reportWidgetClick({
                    widget_name: 'explore-lists',
                    widget_place: 'top',
                    trigger_type: browseNodeName,
                  })
                }
              >
                <img src={image} alt={slug} className="size-24 object-scale-down" loading="lazy" />
                <span className="mt-4 text-center text-base font-normal leading-5 tablet:text-start">
                  {browseNodeName}
                </span>
                <div
                  className={clsx(
                    'mt-auto w-full rounded-[50px] py-[1px] text-center text-[15px] font-light uppercase tablet:text-[13px]',
                    stylesBydomain.HOMEPAGE_BUTTON_PRIMARY,
                    'homepage_button_primary',
                  )}
                >
                  {translations.Home.viewList}
                </div>
              </Link>
            </Fragment>
          ))}
        </div>
      </div>
    )
  )
}

export default ExploreLists
